import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { ClickAwayListener, Popper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toColonTimeFromMs } from 'services/helpers/time';
import {
  CustomSlider,
  TimeInterval,
  SliderContainer,
  StyledButton,
} from './styled';

type PropsType = {
  minValue: number;
  maxValue: number;
  initialMinValue: number;
  initialMaxValue: number;
  onUpdate: (duration: Array<number>) => void;
};

const DurationFilter = (props: PropsType) => {
  const { minValue, maxValue, initialMinValue, initialMaxValue, onUpdate } =
    props;
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [duration, setDuration] = useState([initialMinValue, initialMaxValue]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setDuration([initialMinValue, initialMaxValue]);
  }, [initialMinValue, initialMaxValue]);
  // @ts-ignore
  const handleDurationChange = (event, newValue) => {
    setDuration(newValue);
  };

  const prepareTextForTimeInterval = (min: number, max: number): string =>
    t('filtersBar:duration:selected', {
      minValue: toColonTimeFromMs(min),
      maxValue: toColonTimeFromMs(max),
    });

  const durationText = (): string => {
    if (duration[0] < minValue + 1000 && duration[1] > maxValue - 1000) {
      return t('filtersBar:duration:any');
    }
    return prepareTextForTimeInterval(duration[0], duration[1]);
  };

  return (
    <>
      <StyledButton
        onClick={(event) => {
          setAnchorEl(anchorEl ? null : event.currentTarget);
          setIsOpen(!isOpen);
        }}
        endIcon={isOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        disableRipple
      >
        <Typography variant="body1">{durationText()}</Typography>
      </StyledButton>
      <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement="bottom"
        disablePortal
      >
        <ClickAwayListener
          onClickAway={() => {
            setIsOpen(false);
            setAnchorEl(null);
          }}
        >
          <SliderContainer>
            <CustomSlider
              min={minValue}
              max={maxValue}
              value={duration}
              onChange={handleDurationChange}
              onChangeCommitted={() => onUpdate(duration)}
              aria-labelledby="range-slider"
            />
            <TimeInterval>
              {prepareTextForTimeInterval(duration[0], duration[1])}
            </TimeInterval>
          </SliderContainer>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default DurationFilter;
